module.exports = __webpack_public_path__ + "static/media/img3-2.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/FE/img3-2.png
// module id = 1928
// module chunks = 3